<!--<app-header></app-header>-->
<div class="MainBg">
  <div class="MainInnerForm IFA_Mob_Margin">
    <div *ngIf="!IsMobile" class="SideMenu ValueAdds">
      <div class="SideMenuHeading">Resources</div>
      <div class="SideMenuLinks">
        <ul class="nav nav-tabs">
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/branding"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Branding_Module_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Branding Images</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-returns"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Top_Returns_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Scheme Returns</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancelumpsum"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Lumpsum.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancecompare"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Comparison.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Best Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-nav"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/NAVs_report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme NAV</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-dividend"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Dividends_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Dividend</span>
            </a>
          </li>
          <!-- <li class="SideMenuLinksInner">
                  <a routerLink='/value-add-service/new-nfo' routerLinkActive='active'>
                    <img src="../../../assets/images/IFA/Reports Icon/New_NFO_Report.svg" width="25" class="SideMenuIcon svg" type="image/svg+xml"
                      pluginspage="http://www.adobe.com/svg/viewer/install/" />
                    <span>NFO</span>
                  </a>
                </li> -->
          <li class="SideMenuLinksInner">
            <a routerLink="/value-add-service/forms" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/MF_Forms.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>MF Forms</span>
            </a>
          </li>
          <li class="SideMenuLinksInner" *ngIf="IsSubscribed">
            <a
              class="active show"
              routerLink="/value-add-service/scheduleclient"
              routerLinkActive="active">
              <!-- <img
                src="../../../assets/images/IFA/Reports Icon/Schedule_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" /> -->
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.64478 0.666748V2.3109H1.00075L2.64478 0.666748Z" fill="#12344D"/>
                  <path d="M2.53332 2.62543C2.77062 2.62543 2.96301 2.43304 2.96301 2.19574V0.666773L10.2726 0.666748C10.9834 0.666748 11.5616 1.24502 11.5616 1.95581V6.75941C11.4201 6.74658 11.2768 6.73967 11.132 6.73967C9.66735 6.73967 8.35626 7.4093 7.48861 8.45842C7.24412 8.78937 7.11388 8.97599 6.92251 9.3178C6.65393 9.8419 6.48073 10.4225 6.42513 11.0365C6.40088 11.3456 6.39985 11.5337 6.42513 11.8959C6.55364 13.315 7.31184 14.555 8.41754 15.3334H2.28994C1.57915 15.3334 1.00088 14.7551 1.00088 14.0443V2.62543H2.53332Z" fill="#12344D"/>
                  <path d="M11.132 7.59912C13.2643 7.59912 14.9991 9.33394 14.9991 11.4663C14.9991 13.5987 13.2643 15.3335 11.132 15.3335C8.99959 15.3335 7.26477 13.5987 7.26477 11.4663C7.26477 9.33394 8.99959 7.59912 11.132 7.59912ZM9.98612 11.896H11.132C11.3693 11.896 11.5616 11.7036 11.5616 11.4663V9.74756C11.5616 9.51026 11.3693 9.31787 11.132 9.31787C10.8947 9.31787 10.7023 9.51026 10.7023 9.74756V11.0366H9.98612C9.74882 11.0366 9.55644 11.229 9.55644 11.4663C9.55644 11.7036 9.74882 11.896 9.98612 11.896Z" fill="#12344D"/>
                  <path d="M9.58004 2.16062C9.21941 2.07647 8.85902 2.30226 8.77486 2.66289C8.73578 2.83311 8.76343 3.01193 8.85454 3.16085L7.108 5.28071C7.08328 5.27099 7.05729 5.26098 7.03041 5.25481C6.94594 5.23541 6.85764 5.23266 6.77223 5.24673L6.08314 3.98771C6.15894 3.90406 6.21306 3.80331 6.23991 3.69225C6.32308 3.33005 6.09728 2.96966 5.73508 2.88649C5.37288 2.80332 5.01248 3.02911 4.92931 3.39132C4.89474 3.54775 4.91638 3.71171 4.99301 3.85326L3.39821 5.58221C3.36157 5.56571 3.32278 5.55276 3.28438 5.54394C2.92218 5.46078 2.56179 5.68657 2.47862 6.04877C2.39545 6.41098 2.62124 6.77137 2.98345 6.85454C3.34565 6.93771 3.70604 6.71191 3.78921 6.34971C3.82379 6.19327 3.80215 6.02932 3.72552 5.88776L5.31904 4.15853C5.43504 4.21076 5.56469 4.22706 5.68977 4.20458L6.37885 5.4636C6.30305 5.54724 6.24992 5.64957 6.22336 5.75934C6.13891 6.12126 6.36441 6.48293 6.72504 6.56708C7.08695 6.65153 7.44863 6.42603 7.53278 6.0654C7.57187 5.89518 7.5445 5.71509 7.45369 5.56489L9.20023 3.44502C9.22495 3.45474 9.25094 3.46475 9.27782 3.47092C9.64003 3.55409 10.0004 3.3283 10.0836 2.9661C10.1668 2.60389 9.94224 2.24379 9.58004 2.16062Z" fill="white"/>
                  <path d="M2.44629 10.4446H4.27962" stroke="white" stroke-width="0.611111" stroke-linecap="round"/>
                  <path d="M2.44629 11.6938H5.51975" stroke="white" stroke-width="0.611111" stroke-linecap="round"/>
                  </svg>
                  
              <span>Schedule Report (Beta)</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="FormTemplate">
      <div>
        <div *ngIf="!IsMobile" class="SectionHeading">
          Schedule Report (Under Testing)
        </div>

        <form
          autocomplete="off"
          [formGroup]="ScheduleClientForm"
          class="FormOuter_Mob">
          <div class="MinLeftFormHeightTransact">
            <div [ngClass]="G_UserType != 1 ? 'd-block' : 'd-none'">
              <div
                [ngClass]="
                  l.RdbReportType.value == 'true' ? 'd-block' : 'd-none'
                ">
                <div class="CustomGrid">
                  <div class=" InputBoxOuter DdlInv">
                    <div class="has-float-label">
                      <!-- <select formControlName="ClientBasicInfoId" class="form-control CommonSelectBox TbxMarginBtm CustomSelect0"
                                        [ngClass]="{ 'is-invalid': ScheduleClientsubmitted && l.ClientBasicInfoId.errors }">
                                        <option value="">Select Investor Name</option>
                                        <option *ngFor="let ClientBasicInfoId of SelectedClient" [value]="ClientBasicInfoId.VALUEFIELD">
                                            {{ClientBasicInfoId.TEXTFIELD}}</option>
                                    </select> -->

                      <ng-multiselect-dropdown-angular7
                        [ngModelOptions]="{ standalone: true }"
                        [placeholder]="'Select Investor Name'"
                        [data]="SelectedClient"
                        [(ngModel)]="selectedItems"
                        [settings]="dropdownSettings"
                        (onSelect)="onItemSelect($event)"
                        (onDeSelect)="onItemSelect($event)"
                        (onSelectAll)="onItemSelectDeselectAll($event, 0)"
                        (onDeSelectAll)="
                          onItemSelectDeselectAll($event, 1)
                        "></ng-multiselect-dropdown-angular7>
                      <label>Investor Name</label>
                      <div
                        *ngIf="
                          ScheduleClientsubmitted && l.ClientBasicInfoId.errors
                        "
                        class="invalid-feedback">
                        <div *ngIf="l.ClientBasicInfoId.errors.required">
                          Please Select Client First
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class=" InputBoxOuter">
                    <div class="has-float-label">
                      <input
                        type="text"
                        id="FromDate"
                        formControlName="FromDate"
                        [ngClass]="{
                          'is-invalid':
                            ScheduleClientsubmitted && l.FromDate.errors
                        }"
                        class="form-control CommonTextBox TbxMarginBtm clsDatePickerFromDate clsCommonDatePicker"
                        placeholder="&nbsp;" />
                      <label for="FromDate">Start Date</label>
                      <div
                        *ngIf="ScheduleClientsubmitted && l.FromDate.errors"
                        class="invalid-feedback">
                        <div *ngIf="l.FromDate.errors.required">
                          Please Select From Date
                        </div>
                        <div *ngIf="l.FromDate.errors.pattern">
                          Please Enter Valid Date
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class=" InputBoxOuter">
                    <div class="has-float-label">
                      <select
                        formControlName="Frequency"
                        class="form-control CommonSelectBox TbxMarginBtm CustomSelect0"
                        [ngClass]="{
                          'is-invalid':
                            ScheduleClientsubmitted &&
                            l.ClientBasicInfoId.errors
                        }">
                        <option value="" disabled="true">
                          Select Frequency
                        </option>
                        <option value="Weekly">Weekly</option>
                        <option value="FortNight">FortNight</option>
                        <option value="Monthly">Monthly</option>
                      </select>
                      <label for="FromDate">Frequency</label>
                    </div>
                  </div>
                  <div  > <!-- style="margin-top: -15px" removed by pradnesh 16/06/2025-->
                    <button
                      class="CommonSubmitButton"
                      style="min-width: 15px !important"
                      [disabled]="
                        ScheduleClientForm.value == '' ||
                        !ScheduleClientForm.valid
                      "
                      (click)="onsubmitScheduleclient()">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <div id="TblReportSection" > <!-- style="margin-left: -32px" removed by pradnesh 16/06/2025-->
                <div
                  [ngClass]="IsShowReport ? 'd-block' : 'd-none'"
                  class="MainInnerFormWithoutFlex IFA_Mob_Margin mt-0">
                  <!-- <div *ngIf='!IsMobile' class="SectionTopHeading HeadingReport Padding_IFA w-100 mb-0 align-items-start">
                                  <span *ngIf='!IsMobile' class="ReportHead">Active SIP Report </span>
                                 </div> -->

                  <div class="d-flex">
                    <!-- <div class="col-4">
                                  </div> -->
                    <div class="col-12 Padding_IFA">
                      <div *ngIf="!IsMobile" class="tab-content pt-0">
                        <div
                          id="scheduleReport"
                          class="tab-pane fade show active">
                          <table
                            id="scheduleReportTable"
                            class="CommonTable ClsReportTable">
                            <thead>
                              <tr>
                                <th class="no-sort">Client Name</th>
                                <th class="no-sort">PAN No.</th>
                                <th class="no-sort">Set On</th>
                                <th class="no-sort">Next Scheduled</th>
                                <th class="no-sort">Frequency</th>
                                <th class="no-sort">Last Executed</th>
                                <th class="no-sort">Remark</th>
                                <th class="no-sort text-center">Status</th>
                                <th class="no-sort text-center">Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let c of ReportData">
                                <td>{{ c.ClientName }}</td>
                                <td>{{ c.PANNo }}</td>
                                <td>{{ c.ScheduleFrom }}</td>
                                <td>{{ c.ScheduleDate }}</td>
                                <td>{{ c.Frequency }}</td>
                                <td>{{ c.LastScheduleDate }}</td>
                                <td>{{ c.Remark }}</td>
                                <td class="text-right">
                                  <span
                                    *ngIf="ReportData.length > 0"
                                    (change)="
                                      Active_InActivestatus(c.ClientId)
                                    ">
                                    <label class="switch">
                                      <input
                                        type="checkbox"
                                        [checked]="
                                          c.status == 0 ? false : true
                                        " />
                                      <span class="slider round"></span>
                                    </label>
                                  </span>
                                </td>
                                <td class="text-center">
                                  <span
                                    *ngIf="ReportData.length > 0"
                                    style="font-size: 26px !important">
                                    <i
                                      class="fa fa-trash ColorRed"
                                      (click)="DeleteClient(c.ClientId)"></i></span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <h6>{{ScheduleClientForm.value | json}}</h6> -->
        </form>
      </div>
    </div>
  </div>
</div>
<span *ngIf="!IsMobile">
  <app-footer></app-footer>
</span>
